import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';
import TextAreaLabel from '../../../exportacion_react_pdf/TextAreaLabel';
import SelectGroup from '../../../exportacion_react_pdf/SelectGroup';
import TablaCalificacion from '../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../exportacion_react_pdf/TextAreaLabelGroup';

const secciones_socio_empresarial = [
    {
        key: "1",
        title: "ASOCIATIVA ",
        questions: [
            {
                section: "1.1",
                description: "Productor/a vinculado en programas de fortalecimiento del tejido social",
            },
        ],
    },
    {
        key: "2",
        title: "2. FINANCIERA",
        questions: [
            {
                section: "2.1",
                description: "Productor/a reconoce la importancia de manejar temas financieros y contables",
            },
            {
                section: "2.2",
                description: "Productor/a conoce e identifica las condiciones del crédito agropecuario",
            },
            {
                section: "2.3",
                description: "Productor/a participa en programas de inclusión financiera",
            },
        ],
    },
    {
        key: "3",
        title: "3. COMERCIAL",
        questions: [
            {
                section: "3.1",
                description: "Productor/a participa en eventos de promoción, ferias, mercados campesinos, etc",
            },
            {
                section: "3.2",
                description: "Productor/a conoce normas de calidad y parámetros de marca",
            },
            {
                section: "3.3",
                description: "Productor/a apropiado de su plan de negocios",
            },
            {
                section: "3.4",
                description: "Productor/a identifica los eslabones de la cadena productiva para el desarrollo de valor agregado",
            },
            {
                section: "3.5",
                description: "Productor/a capacitado en temas referidos al establecimiento de alianzas comerciales",
            },
        ],
    },
    {
        key: "4",
        title: "4. TICS",
        questions: [
            {
                section: "4.1",
                description: "Productor/a maneja herramientas ofimáticas básicas",
            },
        ],
    },
];

// Define el documento
const ExportPaso4 = ({ formData, styles }) => {
    return (
        <>
            {/* Sección de Identificació del proyecto */}
            <View style={styles.section}>

                <Text style={styles.title_1}>SOCIO-EMPRESARIAL</Text>


                <QuestionResponse
                    label={'¿Se han identificado socios claves en el territorio?'}
                    value={formData?.socios_claves || ''}>
                </QuestionResponse>

                {formData?.socios_claves === 'Otro' && (

                    <QuestionResponse
                        label={'Especifique otro socio clave'}
                        value={formData?.otra_socio_clave || ''}>
                    </QuestionResponse>
                )}

                <SelectGroup
                    label='¿Qué riesgos ha identificado en el desarrollo de su negocio?'
                    selectedValue={formData?.riesgos_desarrollo_negocio || ''}>
                </SelectGroup>


                {formData?.riesgos_desarrollo_negocio?.includes('Otro') && (
                    <QuestionResponse
                        label={'Especifique otro riesgo'}
                        value={formData?.otro_riesgos_desarrollo_negocio || ''}>
                    </QuestionResponse>
                )}



                <CheckboxGroup
                    label='¿Existen otras fuentes de ingreso diferentes al proyecto productivo?'
                    selectedValue={formData?.otras_fuentes_ingreso || ''}>
                </CheckboxGroup>

                {formData?.otras_fuentes_ingreso === 'Sí' && (

                    <TextAreaLabel
                        label={'¿Cuáles son?'}
                        value={formData?.cuales_fuentes_ingreso || ''}>
                    </TextAreaLabel>
                )}

                <TextAreaLabel
                    label={'¿Cuál considera que es el mayor reto que tiene la unidad productiva en este momento?'}
                    value={formData?.mayor_reto_unidad_productiva || ''}>
                </TextAreaLabel>


                <CheckboxGroup
                    label='¿Han tenido acceso a recursos, apoyos o alianzas específicas para mujeres, personas jóvenes, población étnica y/o en condición de discapacidad?'
                    selectedValue={formData?.acceso_recursos || ''}>
                </CheckboxGroup>

                {formData?.acceso_recursos === 'Sí' && (

                    <TextAreaLabel
                        label={'¿Cuáles? (ej. programas para mujeres emprendedoras, apoyos para personas con discapacidad)'}
                        value={formData?.cuales_acceso_recursos || ''}>
                    </TextAreaLabel>
                )}

                <Text style={styles.title_1}>CAPACIDADES SOCIO-EMPRESARIAL</Text>

                <TablaCalificacion evaluacion={formData?.capacidades_socio_empresarial} secciones={secciones_socio_empresarial}></TablaCalificacion>
                {/* Título principal */}
                <Text style={styles.tag}>
                    SEGUNDA PARTE. PROPUESTA PLAN DE ACOMPAÑAMIENTO INTEGRAL BASADO EN MEJORAMIENTO DE INDICADORES
                </Text>

                {/* Título secundario */}
                <Text style={styles.greyTag}>
                    SELECCIÓN DE INDICADORES
                </Text>

                {/* Nota para el equipo */}
                <Text style={styles.noteTitle}>
                    NOTA PARA EL EQUIPO
                </Text>
                <Text style={styles.noteText}>
                    En este punto se deben identificar los aspectos que es posible mejorar en el predio, considerando la realidad del productor,
                    condiciones de la finca, recursos, tiempo, etc. Se sugiere seleccionar un máximo de 6 indicadores a mejorar. Los indicadores
                    deben seleccionarse de manera conjunta con el productor, quien recibirá acompañamiento y responderá por los procesos y las
                    recomendaciones dadas para su cumplimiento.
                </Text>



                <TextAreaLabelGroup
                    label='Nombre del indicador'
                    selectedValue={formData?.capacidades_socio_empresarial?.seleccion_indicador?.nombre_indicador || ''}>
                </TextAreaLabelGroup>


                {/* Título secundario */}
                <Text style={styles.greyTag}>
                    SECCIÓN PLAN DE ACOMPAÑAMIENTO INTEGRAL - MÓDULOS FORTALECIMIENTO

                </Text>


                <Text style={styles.noteText}>
                    Temas de interes del productor, y requeridos para el mejoramiento de los indicadores seleccionados. Se
                    recomienda priorizar y elegir unicamente los asociados a cumplimiento de indicadores.
                </Text>


                <TextAreaLabelGroup
                    label='Asociativa'
                    selectedValue={formData?.capacidades_socio_empresarial?.acompanamiento_integral?.asociativa || ''}>
                </TextAreaLabelGroup>

                <TextAreaLabelGroup
                    label='Área financiera'
                    selectedValue={formData?.capacidades_socio_empresarial?.acompanamiento_integral?.area_financiera || ''}>
                </TextAreaLabelGroup>

                <TextAreaLabelGroup
                    label='Área administrativa'
                    selectedValue={formData?.capacidades_socio_empresarial?.acompanamiento_integral?.area_administrativa || ''}>
                </TextAreaLabelGroup>

                <TextAreaLabelGroup
                    label='Area Comercial'
                    selectedValue={formData?.capacidades_socio_empresarial?.acompanamiento_integral?.area_comercial || ''}>
                </TextAreaLabelGroup>

                <TextAreaLabelGroup
                    label='TIC´S'
                    selectedValue={formData?.capacidades_socio_empresarial?.acompanamiento_integral?.tics || ''}>
                </TextAreaLabelGroup>
            </View>
        </>
    )

};

export default ExportPaso4;